import type { ContractSchema } from '@libs/data-access/entities'

export function isContractInFullProgressBetween(
  contract: ContractSchema,
  startDatePeriod?: string,
  endDatePeriod?: string
) {
  if (!startDatePeriod || !endDatePeriod) {
    return false
  }
  const validContractStartDate = contract.contract_start
  const validContractEndDate = contract.contract_end

  const startBeforeStartPeriod = !validContractStartDate
    ? true
    : validContractStartDate && startDatePeriod >= validContractStartDate

  const endAfterEndPeriod = !validContractEndDate
    ? true
    : validContractEndDate && endDatePeriod <= validContractEndDate

  return endAfterEndPeriod && startBeforeStartPeriod
}
